export default {

  getMaxValueAxisXLine: (doughnutData) => {
    const columnsLineChart = new Set(
      doughnutData.map((register) => register.label)
    )
    return Math.max(...Array.from(columnsLineChart))
  },

  normalizeAxisXData: (maxLabel) => {
    const filledArray = []
    let currentLabel = 1

    while (currentLabel <= maxLabel) {
      filledArray.push(currentLabel.toString())
      currentLabel++
    }

    return filledArray
  }

}
